import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-create-schedule',
	templateUrl: './create-schedule.component.html',
	styleUrls: ['./create-schedule.component.scss']
})
export class CreateScheduleComponent implements OnInit {
	diasColumns = ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO', 'DOMINGO'];
	displayColumns = ['dias', 'horario', 'accion'];
	dataSource = [1];
	dataSource2: any = [];
	idhorariocampana = null;
	auxHorario: any = [];

	constructor(@Inject(MAT_DIALOG_DATA) public data,
		private gateway: GatewayService,
		private spinner: NgxSpinnerService,
		private dialogRef: MatDialogRef<CreateScheduleComponent>,
		public localSave: LocalSaveService,
		public tabController: ComponentTabController,
		public snackbar: MatSnackBar
	) { }

	ngOnInit() {
		this.getSchedule();
		if (this.localSave.get('solo_ver')) {
			this.displayColumns = ['dias', 'horario'];
		} else {
			this.displayColumns = ['dias', 'horario', 'accion'];
		}
	}

	onNoClick() {
		this.localSave.delete('campana');
		this.dialogRef.close();
	}

	grupoVal = new FormGroup({
		lunes: new FormControl(''),
		martes: new FormControl(''),
		miercoles: new FormControl(''),
		jueves: new FormControl(''),
		viernes: new FormControl(''),
		sabado: new FormControl(''),
		domingo: new FormControl(''),
		horaini: new FormControl('', [Validators.required, Validators.min(7), Validators.max(20)]),
		horafin: new FormControl('', [Validators.required, Validators.max(20)]),
	});

	getSchedule() {
		this.gateway.get('obtenerhorario', { IDCAMPANA: this.localSave.get('campana') }).then((result) => {

			let auxresult: any = result;
			auxresult = auxresult.rows;
			this.idhorariocampana = auxresult[0].idhorariocampana;
			this.auxHorario = auxresult;
			this.dataSource2 = new MatTableDataSource(this.auxHorario);
		}
		).catch(function (e) {
		});

	}

	agregarHorario() {
		let HORARIO: any = {
			diaejecucion: ''
		};

		const arrayaux = [];
		const horaaux = { diaejecucion: '', horainicio: 0, horafin: 0 };

		if (this.grupoVal.controls.lunes.value) {
			arrayaux.push({ diaejecucion: 'L', horainicio: this.grupoVal.controls.horaini.value, horafin: this.grupoVal.controls.horafin.value });
		}
		if (this.grupoVal.controls.martes.value) {
			arrayaux.push({ diaejecucion: 'M', horainicio: this.grupoVal.controls.horaini.value, horafin: this.grupoVal.controls.horafin.value });
		}
		if (this.grupoVal.controls.miercoles.value) {
			arrayaux.push({ diaejecucion: 'Mi', horainicio: this.grupoVal.controls.horaini.value, horafin: this.grupoVal.controls.horafin.value });
		}
		if (this.grupoVal.controls.jueves.value) {
			arrayaux.push({ diaejecucion: 'J', horainicio: this.grupoVal.controls.horaini.value, horafin: this.grupoVal.controls.horafin.value });
		}
		if (this.grupoVal.controls.viernes.value) {
			arrayaux.push({ diaejecucion: 'V', horainicio: this.grupoVal.controls.horaini.value, horafin: this.grupoVal.controls.horafin.value });
		}
		if (this.grupoVal.controls.sabado.value) {
			arrayaux.push({ diaejecucion: 'S', horainicio: this.grupoVal.controls.horaini.value, horafin: this.grupoVal.controls.horafin.value });
		}
		if (this.grupoVal.controls.domingo.value) {
			arrayaux.push({ diaejecucion: 'D', horainicio: this.grupoVal.controls.horaini.value, horafin: this.grupoVal.controls.horafin.value });
		}

		HORARIO.horainicio = this.grupoVal.controls.horaini.value;
		HORARIO.horafin = this.grupoVal.controls.horafin.value;

		// console.log(this.auxHorario);
		// console.log(arrayaux);

		function validarHorario(idcampana, index, auxHorarioin, arrayauxin, that) {
			if (arrayauxin.length > index) {
				let found = auxHorarioin.find(horario => String(horario.diaejecucion) == String(arrayauxin[index].diaejecucion)
					&& ((String(horario.horafin) == String(arrayauxin[index].horafin) && String(horario.horainicio) == String(arrayauxin[index].horainicio))
						|| (arrayauxin[index].horainicio >= horario.horainicio && arrayauxin[index].horainicio <= horario.horafin)
						|| (arrayauxin[index].horafin >= horario.horainicio && arrayauxin[index].horafin <= horario.horafin)
						|| (arrayauxin[index].horainicio <= horario.horainicio && arrayauxin[index].horafin >= horario.horafin)
					)
				);
				// console.log(found)
				if (typeof (found) != "undefined" && found != null) {
					that.snackbar.open("Error, Horario ya existente", 'Cerrar', { duration: 3000 });
					index = index + 1;
					validarHorario(idcampana, index, auxHorarioin, arrayauxin, that);
				} else {
					that.gateway.save('validatraslapehorariocampana',
						{ horainicio: arrayauxin[index].horainicio, horafin: arrayauxin[index].horafin, diaejecucion: arrayauxin[index].diaejecucion, idcampana: idcampana }).then((result: any) => {
							//that.tabController.index = 2;
							if (result.validacion == 0) {
								auxHorarioin.push(arrayauxin[index]);
								that.dataSource2 = new MatTableDataSource(auxHorarioin);
								//console.log(this.auxHorario);
								that.grupoVal.controls.lunes.setValue(''); that.grupoVal.controls.martes.setValue('');
								that.grupoVal.controls.miercoles.setValue(''); that.grupoVal.controls.jueves.setValue('');
								that.grupoVal.controls.viernes.setValue(''); that.grupoVal.controls.sabado.setValue('');
								that.grupoVal.controls.domingo.setValue('');
							} else {
								let diaaux = '';
								if (arrayauxin[index].diaejecucion == 'L') {
									diaaux = 'Lunes';
								} else if (arrayauxin[index].diaejecucion == 'M') {
									diaaux = 'Martes';
								} else if (arrayauxin[index].diaejecucion == 'Mi') {
									diaaux = 'Miercoles';
								} else if (arrayauxin[index].diaejecucion == 'J') {
									diaaux = 'Jueves';
								} else if (arrayauxin[index].diaejecucion == 'V') {
									diaaux = 'Viernes';
								} else if (arrayauxin[index].diaejecucion == 'S') {
									diaaux = 'Sabado';
								} else if (arrayauxin[index].diaejecucion == 'D') {
									diaaux = 'Domingo';
								}

								that.snackbar.open("Error, el horario " + diaaux + " " + arrayauxin[index].horainicio + "-" + arrayauxin[index].horafin + " tiene traslape con campañas de un agente", 'Cerrar', { duration: 3000 });
							}
							index = index + 1;
							validarHorario(idcampana, index, auxHorarioin, arrayauxin, that);
						}
						).catch(function (e) {
						});
				}
			} else {
				that.spinner.hide();
			}
		}

		this.spinner.show();
		validarHorario(this.localSave.get('campana'), 0, this.auxHorario, arrayaux, this);

		// for (var i = 0; i < arrayaux.length; i++) {
		// 	let found = this.auxHorario.find(horario => 	String(horario.diaejecucion) == String(arrayaux[i].diaejecucion) 
		// 												&&( (String(horario.horafin) == String(arrayaux[i].horafin) && 	String(horario.horainicio) == String(arrayaux[i].horainicio) )
		// 													|| (arrayaux[i].horainicio>=horario.horainicio && arrayaux[i].horainicio<=horario.horafin)
		// 													|| (arrayaux[i].horafin>=horario.horainicio && arrayaux[i].horafin<=horario.horafin)
		// 													|| (arrayaux[i].horainicio<=horario.horainicio&&arrayaux[i].horafin>=horario.horafin)
		// 												)
		// 									);
		// 	// console.log(found)
		// 	if(typeof(found)!="undefined" && found != null){
		// 		this.snackbar.open("Error, Horario ya existente", 'Cerrar', {duration:3000});
		// 	}else{
		// 		console.log('===========')
		// 		console.log(arrayaux[i]);
		// 		console.log(this.localSave.get('campana'));
		// 		console.log('//===========')
		// 		this.auxHorario.push(arrayaux[i]);
		// 		this.dataSource2 = new MatTableDataSource(this.auxHorario);
		// 		//console.log(this.auxHorario);
		// 		this.grupoVal.controls.lunes.setValue(''); this.grupoVal.controls.martes.setValue('');
		// 		this.grupoVal.controls.miercoles.setValue(''); this.grupoVal.controls.jueves.setValue('');
		// 		this.grupoVal.controls.viernes.setValue(''); this.grupoVal.controls.sabado.setValue('');
		// 		this.grupoVal.controls.domingo.setValue('');
		// 	}
		// }

	}

	save() {
		this.spinner.show();
		let HORARIO = {
			IDHORARIOCAMPANA: this.idhorariocampana,
			HORARIOS: this.auxHorario,
			IDCAMPANA: this.localSave.get('campana')
		}

		this.gateway.save('createschedule', HORARIO).then((result) => {
			this.spinner.hide();
			this.tabController.index = 2;
		}
		).catch(function (e) {
		});

	}

	borrarHorario(element) {

		let auxind = -1;

		auxind = this.auxHorario.indexOf(element);
		this.auxHorario.splice(auxind, 1)
		this.dataSource2 = new MatTableDataSource(this.auxHorario);

		// let i = 0;
		// this.auxHorario.forEach(sub => {
		// 	if (sub.diaejecucion = element.diaejecucion) this.auxHorario.splice(i, 1);
		// 	i++;
		// });
		// this.dataSource2 = new MatTableDataSource<any>(this.auxHorario);
	}

	getError(type) {
		if (type == 1) {
			if (this.grupoVal.controls.fechaini.hasError('required')) {
				return 'Debes seleccionar una Fecha Inicial';
			}
		}
		else if (type == 2) {
			if (this.grupoVal.controls.fechafin.hasError('required')) {
				return 'Debes seleccionar una Fecha Final';
			}
		}
		else if (type == 3) {
			if (this.grupoVal.controls.horaini.hasError('required')) {
				return 'Debes ingresar un Horario';
			} else
				if (this.grupoVal.controls.horaini.hasError('min')) {
					return 'Debes ingresar una Hora mayor a 7';
				} else
					if (this.grupoVal.controls.horaini.hasError('max')) {
						return 'Debes ingresar una Hora menor a 20';
					}
		}
		else if (type == 4) {
			if (this.grupoVal.controls.horafin.hasError('required')) {
				return 'Debes ingresar un Horario';
			} else
				if (this.grupoVal.controls.horafin.hasError('min')) {
					return 'Debes ingresar una Hora mayor a 7';
				} else
					if (this.grupoVal.controls.horafin.hasError('max')) {
						return 'Debes ingresar una Hora menor a 20';
					}
		}
	}
}
